import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Maybe from "components/__new/common/Maybe";
import CurrencyFormat from "utils/currencyFormat";
import NumberFormat from "utils/numberFormat";
import { ReactComponent as IconDeductions } from "assets/images/icons/project-icons/deductions.svg";
import { ReactComponent as IconNetpay } from "assets/images/icons/project-icons/netpay.svg";
import { ReactComponent as IconPeopleGroup } from "assets/images/icons/project-icons/people-group.svg";
import { ReactComponent as IconStar } from "assets/images/icons/project-icons/star.svg";
import ContentLoading from "components/__new/common/ContentLoading";


const PayrollInfoCard = ({ label, value, loading, children }) => {
    return (
        <div className="flex-1 bg-white p-5 rounded-xl">
            <div className="flex flex-col justify-between gap-6">
                <div>
                   {children}
                </div>
                <div>
                    <div className="text-sm">{label}</div>
                    <div className="font-semibold text-3xl">
                        <ContentLoading 
                            loading={loading}
                            data={<>{value}</>}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

export const PayrollMetrics = (props) => {
    const { loading, data: payroll } = props;
    
    const contianerClass = "w-max px-4 lg:px-6 border-r border-gray-200";
    const wrapperClass = "mt-2 text-lg font-medium text-[#1f2937]";
    const titleClass = "text-base text-[#718096]"

    return (
        <div /* className="mt-3 py-2 bg-white rounded-md flex items-center justify-start flex-wrap md:flex-nowrap w-max" */ className="flex flex-col lg:flex-row xl:flex-row gap-4">
            {/* <div className={contianerClass}>
                <div className={titleClass}>
                    Employees
                </div>
                <div className={wrapperClass}>
                    <Maybe condition={loading === true}>
                        <FontAwesomeIcon icon="circle-notch" spin />
                    </Maybe>
                    <Maybe condition={loading === false}>
                        {NumberFormat(payroll?.transaction_metrics?.number_of_employees, "no-kobo") || "-"}
                    </Maybe>
                </div>
            </div>
            <Maybe condition={payroll?.type === "GROSS"}>
                <div className={contianerClass}>
                    <div className={titleClass}>
                        Gross Salary
                    </div>
                    <div className={wrapperClass}>
                        <Maybe condition={loading === true}>
                            <FontAwesomeIcon icon="circle-notch" spin />
                        </Maybe>
                        <Maybe condition={loading === false}>
                            {CurrencyFormat(payroll?.transaction_metrics?.total_gross_salary) || "-"}
                        </Maybe>
                    </div>
                </div>
                <PayrollInfoCard
                    label="Employees"
                    value={NumberFormat(payroll?.transaction_metrics?.number_of_employees, "no-kobo") || "-"}
                    loading={loading}
                    children={<><IconPeopleGroup /></>}
                />
            </Maybe>
            <div className={contianerClass}>
                <div className={titleClass}>
                    Deductions
                </div>
                <div className={wrapperClass}>
                    <Maybe condition={loading === true}>
                        <FontAwesomeIcon icon="circle-notch" spin />
                    </Maybe>
                    <Maybe condition={loading === false}>    
                        {CurrencyFormat(payroll?.transaction_metrics?.total_deductions + payroll?.transaction_metrics?.total_on_demand_pay) || "-"}
                    </Maybe>
                </div>
            </div>
            <Maybe condition={payroll?.type === "GROSS"}>
                <div className={contianerClass}>
                    <div className={titleClass}>
                        PAYE Tax
                    </div>
                    <div className={wrapperClass}>
                        <Maybe condition={loading === true}>
                            <FontAwesomeIcon icon="circle-notch" spin />
                        </Maybe>
                        <Maybe condition={loading === false}>
                            {CurrencyFormat(payroll?.transaction_metrics?.total_paye_tax) || "-"}
                        </Maybe>
                    </div>
                </div>
                <div className={contianerClass}>
                    <div className={titleClass}>
                        Pension
                    </div>
                    <div className={wrapperClass}>
                        <Maybe condition={loading === true}>
                            <FontAwesomeIcon icon="circle-notch" spin />
                        </Maybe>
                        <Maybe condition={loading === false}>
                            {CurrencyFormat(payroll?.transaction_metrics?.total_pension) || "-"}
                        </Maybe>
                    </div>
                </div>
            </Maybe>    
            <div className={contianerClass}>
                <div className={titleClass}>
                    Bonuses
                </div>
                <div className={wrapperClass}>
                    <Maybe condition={loading === true}>
                        <FontAwesomeIcon icon="circle-notch" spin />
                    </Maybe>
                    <Maybe condition={loading === false}>
                        {CurrencyFormat(payroll?.transaction_metrics?.total_bonuses + payroll?.transaction_metrics?.total_benefits_in_kind) || "-"}
                    </Maybe>
                </div>
            </div>
            <div className={contianerClass}>
                <div className={titleClass}>
                    Net Pay
                </div>
                <div className={wrapperClass}>
                    <Maybe condition={loading === true}>
                        <FontAwesomeIcon icon="circle-notch" spin />
                    </Maybe>
                    <Maybe condition={loading === false}>
                        {CurrencyFormat(payroll?.transaction_metrics?.total_net_pay) || "-"}
                    </Maybe>
                </div>
            </div> */}
            <PayrollInfoCard
                label="Employees"
                value={NumberFormat(payroll?.transaction_metrics?.number_of_employees, "no-kobo") || "-"}
                loading={loading}
                children={<><IconPeopleGroup /></>}
            />
            <PayrollInfoCard
                label="Net Pay"
                value={CurrencyFormat(payroll?.transaction_metrics?.total_net_pay) || "-"}
                loading={loading}
                children={<><IconNetpay /></>}
            />
            <PayrollInfoCard
                label="Bonuses"
                value={CurrencyFormat(payroll?.transaction_metrics?.total_bonuses + payroll?.transaction_metrics?.total_benefits_in_kind) || "-"}
                loading={loading}
                children={<><IconStar /></>}
            />
            <PayrollInfoCard
                label="Deductions"
                value={CurrencyFormat(payroll?.transaction_metrics?.total_deductions + payroll?.transaction_metrics?.total_on_demand_pay) || "-"}
                loading={loading}
                children={<><IconDeductions /></>}
            />
        </div>
    )
}